import { contact } from '../../portfolio'
import './Contact.css'

const Contact = () => {
  if (!contact.email) return null

  return (
    <section className='section contact center' id='contact'>
      <h2 className='section__title'>Contact</h2>
      <a href={`mailto:${contact.email}`}>
        <span type='text' style={{ cursor: 'pointer', textDecoration: 'underline', color: 'lightblue' }}>
          Email me
        </span>
      </a>
        <span style={{ marginTop: '1rem' }}>
           or submit this contact form
        </span>
    </section>
  )
}

export default Contact
